/**
 * Temporary kill-switch for athlete profile sharing UI.
 * Set to true to restore the Share button and modal on athlete profile pages.
 */
export const PROFILE_SHARING_UI_ENABLED = false;
